<canvas #canvas [id]="id"></canvas>
